import { render, staticRenderFns } from "./rcscolaire_start.vue?vue&type=template&id=37aea298&scoped=true"
import script from "./rcscolaire_start.vue?vue&type=script&lang=js"
export * from "./rcscolaire_start.vue?vue&type=script&lang=js"
import style0 from "./rcscolaire_start.vue?vue&type=style&index=0&id=37aea298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aea298",
  null
  
)

export default component.exports